import { SvgExport } from "yfiles";
export default function renderSvgToPng(svgElement, size, margins) {
    const targetCanvas = document.createElement("canvas");
    const targetContext = targetCanvas.getContext("2d");
    const svgString = SvgExport.exportSvgString(svgElement);
    const svgUrl = SvgExport.encodeSvgDataUrl(svgString);
    if (window.btoa === undefined) {
        targetContext.fillText("This browser does not support SVG previews", 10, 50);
        return new Promise(resolve => {
            resolve(new Image());
        });
    }
    return new Promise(resolve => {
        const svgImage = new Image();
        svgImage.onload = () => {
            targetContext.clearRect(0, 0, targetCanvas.width, targetCanvas.height);
            targetCanvas.width = size.width + (margins.left + margins.right);
            targetCanvas.height = size.height + (margins.top + margins.bottom);
            try {
                targetContext.drawImage(svgImage, margins.left, margins.top);
                const pngImage = new Image();
                pngImage.src = targetCanvas.toDataURL("image/png");
                pngImage.onload = () => {
                    resolve(pngImage);
                };
            }
            catch (error) {
                resolve(new Image());
            }
        };
        svgImage.src = svgUrl;
    });
}
